import moment, { unitOfTime } from "moment";
import { Mask } from "./Mask";
import { masks } from "./masks";

export class TimeMask implements Mask {
  searchValue = masks.celphone.searchValue;
  replaceValue = masks.celphone.replaceValue;
  maxLength: number = 4;
  execute(value: string): string {
    return "";
  }

  format(value: number, unit: unitOfTime.Base): string {
    const duration = moment.duration(value, unit);
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    return `${minutes}:${seconds}`;
  }
}
